import c1 from '../../Assets/img/c1.svg'
import c2 from '../../Assets/img/newMovie.svg'
import c3 from '../../Assets/img/c3.svg'
import c4 from '../../Assets/img/c4.svg'
import c5 from '../../Assets/img/c5.svg'
import c6 from '../../Assets/img/c6.svg'
import c7 from '../../Assets/img/c7.svg'
import c8 from '../../Assets/img/c8.svg'
import c9 from '../../Assets/img/c9.svg'
import c10 from '../../Assets/img/c10.svg'
import c11 from '../../Assets/img/c11.svg'
import c12 from '../../Assets/img/c12.svg'
import c13 from '../../Assets/img/c13.svg'
import c14 from '../../Assets/img/c14.svg'
import c15 from '../../Assets/img/c15.svg'
import c16 from '../../Assets/img/c16.svg'
import c17 from '../../Assets/img/c17.svg'
import c18 from '../../Assets/img/c18.svg'
import c19 from '../../Assets/img/c19.svg'
// import c1 from '../../Assets/img/c1.svg'

export const categories = [
    {
        name: "Music",
        icon: c1,
    },
    {
        name: "Movies",
        icon: c2,
    },
    {
        name: "Comedy",
        icon: c3,
    }, {
        name: "Club",
        icon: c4,
    }, {
        name: "Festivals",
        icon: c5,
    }, {
        name: "Concert",
        icon: c6,
    }, {
        name: "Gaming",
        icon: c7,
    }, {
        name: "Food & Nutrition",
        icon: c8,
    }, {
        name: "Technology",
        icon: c9,
    }, {
        name: "Art & Culture",
        icon: c10,
    }, {
        name: "Hospitality & Tourism",
        icon: c11,
    }, {
        name: "Health",
        icon: c12,
    }, {
        name: "Fashion & Beauty",
        icon: c13,
    }, {
        name: "Business",
        icon: c14,
    }, {
        name: "Party",
        icon: c15,
    }, {
        name: "Exhibition",
        icon: c16,
    }, {
        name: "Sports",
        icon: c17,
    }, {
        name: "Religion",
        icon: c18,
    }, {
        name: "Others",
        icon: c19,
    },
]